import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";

window.__DIR_BUILD_ID__ = process.env.REACT_APP_BUILD_ID || "chrome-globe-test-3-20260824";

async function retireLegacyWorker() {
  if (!("serviceWorker" in navigator)) return;
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    if (!registrations.length) return;
    await Promise.all(registrations.map((registration) => registration.unregister()));
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.filter((key) => /workbox|precache|react|dirnation/i.test(key)).map((key) => caches.delete(key)));
    }
    if (navigator.serviceWorker.controller && sessionStorage.getItem("dirnation-worker-retired") !== "1") {
      sessionStorage.setItem("dirnation-worker-retired", "1");
      window.location.reload();
    }
  } catch (error) {
    console.warn("DIR Nation legacy worker cleanup skipped", error);
  }
}

retireLegacyWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppErrorBoundary><App /></AppErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
